/* eslint-disable max-len */
import React from "react";

interface SVGRProps {
  title?: string;
  titleId?: string;
}

const BrokenSearch = ({
    title,
    titleId = "tm-icon-broken-search",
    ...props
}: React.SVGProps<SVGSVGElement> & SVGRProps) => (
    <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 74 74"
        aria-hidden={!title}
        height="1em"
        width="1em"
        role={title ? "img" : ""}
        aria-labelledby={titleId}
    >
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="none" fillRule="evenodd" opacity={0.5}>
            <path
                fill="#000"
                d="M50.114 8.656l1.86 1.86c10.25 10.25 10.892 26.466 1.929 37.464l18.003 18.004a4 4 0 010 5.657l-.265.265a4 4 0 01-5.657 0L47.98 53.903c-10.998 8.963-27.215 8.32-37.464-1.929l-1.86-1.86c-10.934-10.934-10.934-28.663 0-39.598l1.86-1.86c10.935-10.934 28.664-10.934 39.598 0zm-37.566 3.892c9.812-9.813 25.722-9.813 35.535 0 9.813 9.812 9.813 25.722 0 35.535-9.813 9.813-25.723 9.813-35.535 0-9.813-9.813-9.813-25.723 0-35.535z"
            />
            <path
                stroke="#000"
                strokeLinecap="square"
                d="M11.5 46.5l5.018-2.285V37h5.69l12.058-10.655h15.798V11.904"
            />
            <path
                stroke="#000"
                strokeLinecap="square"
                d="M22.076 37V12.277H37l-3.462-8.904M22.208 37l8.292 5.271L38.522 37l8.482 1.022 10.15-6.166"
            />
        </g>
    </svg>
);

export default BrokenSearch;
